export class Config {
    public static get BASEPATH(): string {
        return 'http://52.28.117.222:2020';
    }
}
